import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';

const SidebarHeader = ({ onBack, onClear }) => (
  <div className="padding">
    <div className="header">
      <div
        tabIndex="-1"
        role="button"
        onKeyDown={() => {}}
        className="back"
        onClick={onBack}
      >
        <Icon name="arrow left" fitted size="large" />
      </div>
      <span className="title titleText">Filter</span>
      <Button size="small" onClick={onClear} content="Clear" />
    </div>
  </div>
);

SidebarHeader.propTypes = {
  onBack: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default SidebarHeader;
